import React from "react";
var __jsx = React.createElement;
import Mailchimp from './Mailchimp';
function MailchimpAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(Mailchimp, {
    mailchimpdata: entry
  });
}
export default MailchimpAdapter;